<mat-button-toggle-group (change)="updateChartType($event)" [value]="chartType" hideSingleSelectionIndicator="true">
  <mat-button-toggle value="bar"><mat-icon> bar_chart </mat-icon></mat-button-toggle>
  <mat-button-toggle value="pie"><mat-icon> pie_chart </mat-icon></mat-button-toggle>
</mat-button-toggle-group>
